// File: components/DutyList/DutyTable.js
import React from "react";

const DutyTable = ({
  currentItems,
  currentPage,
  totalPages,
  setCurrentPage,
  editingIndex,
  editData,
  handleEdit,
  handleEditChange,
  handleCancelEdit,
  handleSaveEdit,
  indexOfFirstItem,
  tableRef,
}) => {
  return (
    <div ref={tableRef} className="bg-white shadow-sm p-3 rounded border border-light">
      <table className="table table-bordered table-hover align-middle">
        <thead className="table-dark text-center">
          <tr>
            <th>#</th>
            <th>Names</th>
            <th>Contact</th>
            <th>Role</th>
            <th>Section</th>
            <th>On Call</th>
            <th>Edit</th>
          </tr>
        </thead>
        <tbody>
          {currentItems.length > 0 ? (
            currentItems.map((d, i) => {
              const actualIndex = indexOfFirstItem + i;
              const isEditing = editingIndex === d.id;

              return (
                <tr key={d.id || i}>
                  <td className="text-center">{actualIndex + 1}</td>
                  {isEditing ? (
                    <>
                      <td>
                        <input
                          className="form-control"
                          value={editData.name || ""}
                          onChange={(e) => handleEditChange("name", e.target.value)}
                        />
                      </td>
                      <td>
                        <input
                          className="form-control"
                          value={editData.contact || ""}
                          onChange={(e) => handleEditChange("contact", e.target.value)}
                        />
                      </td>
                      <td>
                        <input
                          className="form-control"
                          value={editData.role || ""}
                          onChange={(e) => handleEditChange("role", e.target.value)}
                        />
                      </td>
                      <td>
                        <input
                          className="form-control"
                          value={editData.section || ""}
                          onChange={(e) => handleEditChange("section", e.target.value)}
                        />
                      </td>
                      <td>
                        <input
                          className="form-control"
                          value={editData.on_call || ""}
                          onChange={(e) => handleEditChange("on_call", e.target.value)}
                        />
                      </td>
                      <td>
                        <button className="btn btn-sm btn-success me-1" onClick={handleSaveEdit}>
                          Save
                        </button>
                        <button className="btn btn-sm btn-secondary" onClick={handleCancelEdit}>
                          Cancel
                        </button>
                      </td>
                    </>
                  ) : (
                    <>
                      <td>{d.name}</td>
                      <td>{d.contact}</td>
                      <td>{d.role}</td>
                      <td>{d.section}</td>
                      <td>{d.on_call}</td>
                      <td>
                        <button className="btn btn-sm btn-primary" onClick={() => handleEdit(d.id)}>
                          Edit
                        </button>
                      </td>
                    </>
                  )}
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="7" className="text-center text-muted">
                No data found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {totalPages > 1 && (
        <div className="d-flex justify-content-center mt-3">
          <nav>
            <ul className="pagination pagination-sm">
              {[...Array(totalPages).keys()].map((page) => (
                <li
                  key={page}
                  className={`page-item ${page + 1 === currentPage ? "active" : ""}`}
                >
                  <button className="page-link" onClick={() => setCurrentPage(page + 1)}>
                    {page + 1}
                  </button>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      )}
    </div>
  );
};

export default DutyTable;
